import type { ReactNode } from "react";
import { cn } from "../lib/cn";

export interface PageLayoutProps {
	header?: ReactNode;
	sidebar?: ReactNode;
	footer?: ReactNode;
	children: ReactNode;
	className?: string;
}

function PageLayout({
	header,
	sidebar,
	footer,
	children,
	className,
}: PageLayoutProps): ReactNode {
	return (
		<div className={cn("flex min-h-screen flex-col", className)}>
			{header && <div className="sticky top-0 z-40 w-full">{header}</div>}
			<div className="flex flex-1 overflow-hidden">
				{sidebar && <div className="hidden md:flex shrink-0">{sidebar}</div>}
				<main className="flex-1 overflow-y-auto p-4 md:p-6" id="main-content">
					{children}
				</main>
			</div>
			{footer && <div className="shrink-0">{footer}</div>}
		</div>
	);
}
PageLayout.displayName = "PageLayout";

export default PageLayout;
export { PageLayout };
